import PendingActionsIcon from '@mui/icons-material/PendingActions';

const icons = {
  PendingActionsIcon
};

const approvalofvendor = {
  id: 'Approvalofvendor',
  type: 'group',
  children: [
    {
      id: 'Approvalofvendor',
      title: 'Estimate Approval',
      type: 'item',
      url: '/Estimate-Approval',
      icon: icons.PendingActionsIcon,
    }
  ]
};

export default approvalofvendor;
